import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {KMDGameMode} from "../server/KMDGameMode";
import {IFeatureInfo, SPECIAL_SYMBOL_NAMES} from "../server/IKMDData";
import {KMDSymbol} from "../reels/KMDSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {KMDSound} from "../sound/KMDSound";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class KMDBonusIdlePresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.finish();
            }
        });

        tl.to(this, {
            duration: 0.01
        });
        tl.add(() => {
            KennethMustDie.apiPlugin.betHandler.zeroBet();

            if (!KennethMustDie.model.isRestore) {
                KennethMustDie.keypadPlugin.setZeroBetSpinCounter(KennethMustDie.model.gameData.freespinsLeft - 1);
            } else {
                KennethMustDie.keypadPlugin.setZeroBetSpinCounter(KennethMustDie.model.initData.freespinsLeft - 1);
            }

            this.handleStickyThings();
        });
    }

    private handleStickyThings(): void {
        const mode: string = KennethMustDie.model.data.mode,
            nextMode: string = KennethMustDie.model.data.nextMode;
        let canPlaySound: boolean = false; // if anything gets sticky play this sound once only

        if (nextMode === KMDGameMode.FREESPIN_COOL || nextMode === KMDGameMode.FREESPIN_SUPER) {
            const s2Feature: IFeatureInfo = KennethMustDie.model.s2Feature;

            // #479
            canPlaySound = true;

            if (s2Feature.originReelId !== -1) {
                const s2Symbol: KMDSymbol = (KennethMustDie.reelView.reelModels[s2Feature.originReelId].getStopSymbolAt(s2Feature.originSymId - 1).positionable as KMDSymbol);

                KennethMustDie.stickyS2.showStickyS2(s2Symbol.getY());

                if (s2Symbol.name === SPECIAL_SYMBOL_NAMES.S2) {
                    s2Symbol.updateTexture(ArrayHelper.getRandomValue(KennethMustDie.LOW_SYMBOL_NAMES), s2Symbol.splitParts);
                }
            }

            // current mode shouldn't be NORMAL or NORMAL_AVALANCHE => from main game xNudgeWilds can be there with bonus game triggers, but these shouldn't be sticky
            if (mode.indexOf("NORMAL") === -1) {
                // checking in middle 3 main reels
                for (let reelId: number = 1; reelId < KennethMustDie.REELS_NUM - 1; reelId++) {
                    const stopSymbols: SimpleReelModelSymbolData[] = (KennethMustDie.reelView.reelModels[reelId].stopSymbols);

                    stopSymbols.forEach((symbol: SimpleReelModelSymbolData) => {
                        if ((symbol.positionable as KMDSymbol).originalName === SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD) {
                            KennethMustDie.stickyXNudges.showStickyXNudge(reelId, symbol.reelPosition);
                        }
                    });
                }
            }
        }

        if (nextMode === KMDGameMode.FREESPIN_SUPER) {
            const xHSymbol: KMDSymbol = (KennethMustDie.reelView.reelModels[2].getStopSymbolAt(1).positionable as KMDSymbol);
            if (xHSymbol.name === SPECIAL_SYMBOL_NAMES.XH) {
                xHSymbol.updateTexture(ArrayHelper.getRandomValue(KennethMustDie.LOW_SYMBOL_NAMES), 1);
            }

            KennethMustDie.stickyXH.showStickyXH();
        }

        // current mode shouldn't be NORMAL or NORMAL_AVALANCHE => from main game Wilds can be there with bonus game triggers, but these shouldn't be sticky
        // any of the bonus game mode as wilds are sticky in every type of FS
        if (mode.indexOf("NORMAL") === -1 && nextMode.indexOf("FREESPIN") > -1) {
            // checking in middle 3 main reels
            for (let reelId: number = 1; reelId < KennethMustDie.REELS_NUM - 1; reelId++) {
                const stopSymbols: SimpleReelModelSymbolData[] = (KennethMustDie.reelView.reelModels[reelId].stopSymbols);

                stopSymbols.forEach((symbol: SimpleReelModelSymbolData) => {
                    if ((symbol.positionable as KMDSymbol).originalName === SPECIAL_SYMBOL_NAMES.W) {
                        KennethMustDie.stickyWilds.showStickyWild(reelId, symbol.reelPosition, symbol.reelPosition);

                        canPlaySound = true;
                    }
                });
            }
        }

        // #445, #479
        if (canPlaySound) {
            KennethMustDie.soundPlayer.playSound(KMDSound.SYM_CHAIN_ADD);
        }
    }
}